import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';

import styles from './styles.module.scss';

/**
 * @param {object} props
 * @param {object} props.pros - An object with an items array and a (null or string) label
 * @param {object} props.cons - An object just like the pros
 * @param {string} props.dataActivityMapId
 * @param {boolean} props.isOde
 * @returns {React.ReactElement}
 */
export const ProsCons = ({
  pros, cons, dataActivityMapId, isOde,
}) => (
  <div
    className={classNames(styles.prosConsContainer, { [styles.isOde]: isOde })}
    data-testid="listicle-product__pros-cons-container"
    data-activity-map={dataActivityMapId}
  >
    <div className={styles.prosConsChild}>
      <div className={styles.prosConsLabel}>
        {pros.label || i18next.t('What we like')}
      </div>
      <ul className={styles.prosConsItems}>
        {pros.items.slice(0, 3).map((pro) => (
          /* eslint-disable-next-line react/no-danger */
          <li key={pro} dangerouslySetInnerHTML={{ __html: pro }} />
        ))}
      </ul>
    </div>
    <div className={styles.prosConsChild}>
      <div className={styles.prosConsLabel}>
        {cons.label || i18next.t('Something to note')}
      </div>
      {cons.items?.length > 0 && (
        <ul className={styles.prosConsItems}>
          {cons.items.slice(0, 3).map((con) => (
            /* eslint-disable-next-line react/no-danger */
            <li key={con} dangerouslySetInnerHTML={{ __html: con }} />
          ))}
        </ul>
      )}
      {!(cons.items?.length > 0) && (
        <div className={styles.prosConsFallback}>
          {i18next.t('Nothing to note at this time')}
        </div>
      )}
    </div>
  </div>
);
